var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "75vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_modal = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("cancellation_requests")) +
                    "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "shadow-1",
                  attrs: { animated: "", color: "secondary" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "awaiting_approval",
                      icon: "fas fa-hourglass-half",
                      label: _vm.$t("awaiting_approval")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "cancellation_approved",
                      icon: "far fa-calendar-check",
                      label: _vm.$t("enrollment_canceled")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "cancellation_reproved",
                      icon: "far fa-times-circle",
                      label: _vm.$t("cancellation_reproved")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "awaiting_approval", "keep-alive": "" }
                    },
                    [
                      _c("awaiting-approval", {
                        attrs: {
                          load:
                            _vm.tab === "awaiting_approval" &&
                            _vm.show_enrollment_modal
                              ? true
                              : false,
                          is_admin: _vm.is_admin
                        },
                        on: { change_tab: _vm.changeTab }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "cancellation_approved", "keep-alive": "" }
                    },
                    [
                      _c("cancellation-approved", {
                        attrs: {
                          load:
                            _vm.tab === "cancellation_approved" &&
                            _vm.show_enrollment_modal
                              ? true
                              : false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "cancellation_reproved", "keep-alive": "" }
                    },
                    [
                      _c("cancellation-reproved", {
                        attrs: {
                          load:
                            _vm.tab === "cancellation_reproved" &&
                            _vm.show_enrollment_modal
                              ? true
                              : false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }